module.exports = __webpack_public_path__ + "static/media/Girl.fa647aad.svg";